@if (active()) {
  <div class="impersonation-banner" data-testid="impersonation-banner">
    <span class="impersonation-banner-message">
      Acting as <strong>{{ impersonatedUser()?.name }}</strong> ({{ impersonatedUser()?.email }}) —
      actions will be recorded on their behalf.
    </span>
    <button class="impersonation-banner-exit" data-testid="impersonation-banner-exit" (click)="exit()">
      Exit Impersonation
    </button>
  </div>
}
